module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-6-0c24d8b30ef4b0e3c1db7fc78c01159a.svg";